/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

var currentSummaryIndex = 0;
// Summary indexes
var deviationJitterPageIndex = 0;
var attenuatedSignalPageIndex = 0;
var noisePageIndex = 0;
var faultPageIndex = 0;
var retryPageIndex = 0;
var invertedPolarityPageIndex = 0;
var disclaimerPageIndex = 0;

export class TsExpertReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      firstDeviationJitterPage: -1,
      firstAttenuatedSignalnPage: -1,
      firstNoisePage: -1,
      firstFaultPage: -1,
      firstRetryPage: -1,
      firstInvertedPolarityPage: -1,
      // Summary numbering control
      isFirstDeviationJitterPage: true,
      isFirstAttenuatedSignalnPage: true,
      isFirstNoisePage: true,
      isFirstFaultPage: true,
      isFirstRetryPage: true,
      isFirstInvertedPolarityPage: true,
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  formatTime = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problem.time !== undefined && problem.time !== null) {
      const eventTimeInMillis = problem.time * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  formatTime2 = (problemTime, ntp) => {
    if (ntp !== null && ntp === true) {
      let parsedMillis = Date.parse(problemTime);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problemTime !== undefined && problemTime !== null) {
      const eventTimeInMillis = problemTime * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }
  /*
    The measurement time that is retrieved from the database comes as a string.
    We had a problem that the time that was being retrieved was not correct. 
    The workarround we found for this was to remove the last two characters of 
    the string and it miraculously it was in the format we nedded 
  */
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getAnalysisInit = () => {
    let drawDate = this.whenWasTurnedOnAsDate(this.props.uptime);
    let year = drawDate.getFullYear();
    let month = drawDate.getMonth() + 1;
    let day = drawDate.getDate();
    let hour = drawDate.getHours();
    let minutes = drawDate.getMinutes();
    let seconds = drawDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.TS_EXPERT_REPORT_EXPORT_NAME} - {Strings.CHANNEL} {this.props.channel}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, ${Strings.PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "deviationJitter" && this.state.isFirstDeviationJitterPage) {
      this.setState({
        firstDeviationJitterPage: pageNumber + 1,
        isFirstDeviationJitterPage: false
      });
    }
    else if (reportPart === "attenuatedSignal" && this.state.isFirstAttenuatedSignalnPage) {
      this.setState({
        firstAttenuatedSignalnPage: pageNumber + 1,
        isFirstAttenuatedSignalnPage: false
      });
    }
    else if (reportPart === "noise" && this.state.isFirstNoisePage) {
      this.setState({
        firstNoisePage: pageNumber + 1,
        isFirstNoisePage: false
      });
    }
    else if (reportPart === "fault" && this.state.isFirstFaultPage) {
      this.setState({
        firstFaultPage: pageNumber + 1,
        isFirstFaultPage: false
      });
    }
    else if (reportPart === "retry" && this.state.isFirstRetryPage) {
      this.setState({
        firstRetryPage: pageNumber + 1,
        isFirstRetryPage: false
      });
    }
    else if (reportPart === "reversedPolarity" && this.state.isFirstInvertedPolarityPage) {
      this.setState({
        firstInvertedPolarityPage: pageNumber + 1,
        isFirstInvertedPolarityPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.TS_EXPERT_REPORT_EXPORT_NAME}>
      {this.createIntroPage()}
      {this.createChannelPage(this.props.channel)}
      {this.createSummaryPage()}
      {this.createDeviationJitterPages()}
      {this.createAttenuatedSignalPages()}
      {this.createNoisePages()}
      {this.createFaultPages()}
      {this.createRetryPages()}
      {this.createInvertedPolarityPages()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>{Strings.TS_EXPERT_DP}</Text>
        <Text style={reusableStyles.mainTitle2}>{Strings.ACTIONS_LIST}</Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  createChannelPage = (channel) => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <View style={{
          height: "1px",
          width: "100px",
          backgroundColor: "black",
          marginLeft: "auto",
          marginRight: "auto"
        }}></View>

        <Text style={{
          textAlign: "center",
          fontSize: 18,
          marginTop: "2vh",
          marginBottom: "2vh",
          fontWeight: "bold",
          fontFamily: "RobotoMedium"
        }}>{Strings.CHANNEL + " " + channel}</Text>

        <View style={{
          height: "1px",
          width: "60px",
          backgroundColor: "black",
          marginLeft: "auto",
          marginRight: "auto"
        }}></View>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        {this.getSummaryItem(Constants.ASI_DEVIATION_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.ASI_ATTENUATED_SIGNAL_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.ASI_NOISE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.ASI_FAULT_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.ASI_RETRY_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.ASI_INVERTED_POLARITY_PROBLEM_TYPE)}
        {this.getSummaryItem("disclaimer")}

        {this.getPageFooter()}

      </Page>
    );
  }

  getSummaryItem = (type) => {
    if (type === Constants.ASI_DEVIATION_PROBLEM_TYPE && this.props.deviationJitter.length > 0) {
      currentSummaryIndex++;
      deviationJitterPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {deviationJitterPageIndex}. {Strings.ASI_DEVIATION_LIST_HEADER} {Strings.ASI_DEVIATION_DOTS} {this.state.firstDeviationJitterPage}
        </Text>
      );
    }
    else if (type === Constants.ASI_ATTENUATED_SIGNAL_PROBLEM_TYPE && this.props.attenuatedSignal.length > 0) {
      currentSummaryIndex++;
      attenuatedSignalPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {attenuatedSignalPageIndex}. {Strings.ASI_ATTENUATED_SIGNAL_LIST_HEADER} {Strings.ASI_ATTENUATED_SIGNAL_DOTS} {this.state.firstAttenuatedSignalnPage}
        </Text>
      );
    }
    else if (type === Constants.ASI_NOISE_PROBLEM_TYPE && this.props.noise.length > 0) {
      currentSummaryIndex++;
      noisePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {noisePageIndex}. {Strings.ASI_NOISE_LIST_HEADER} {Strings.ASI_NOISE_DOTS} {this.state.firstNoisePage}
        </Text>
      );
    }
    else if (type === Constants.ASI_FAULT_PROBLEM_TYPE && this.props.fault.length > 0) {
      currentSummaryIndex++;
      faultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {faultPageIndex}. {Strings.ASI_FAULT_LIST_HEADER} {Strings.ASI_FAULT_DOTS} {this.state.firstFaultPage}
        </Text>
      );
    }
    else if (type === Constants.ASI_RETRY_PROBLEM_TYPE && this.props.retry.length > 0) {
      currentSummaryIndex++;
      retryPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {retryPageIndex}. {Strings.ASI_RETRY_LIST_HEADER} {Strings.ASI_RETRY_DOTS} {this.state.firstRetryPage}
        </Text>
      );
    }
    else if (type === Constants.ASI_INVERTED_POLARITY_PROBLEM_TYPE && this.props.reversedPolarity.length > 0) {
      currentSummaryIndex++;
      invertedPolarityPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {invertedPolarityPageIndex}. {Strings.ASI_INVERTED_POLARITY_LIST_HEADER} {Strings.INVERTED_POLARITY_DOTS} {this.state.firstInvertedPolarityPage}
        </Text>
      );
    }
    else if (type === "disclaimer") {
      currentSummaryIndex++;
      disclaimerPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS} ${totalPages}`
        )} fixed />
      );
    }
  }

  resetSummaryIndexes = () => {
    currentSummaryIndex = 0;
    deviationJitterPageIndex = 0;
    attenuatedSignalPageIndex = 0;
    noisePageIndex = 0;
    faultPageIndex = 0;
    retryPageIndex = 0;
    invertedPolarityPageIndex = 0;
    disclaimerPageIndex = 0;
  }

  // ----------------- DEVIATION JITTER -----------------
  createDeviationJitterPages = () => {
    if (this.props.deviationJitter.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{deviationJitterPageIndex}{Strings.ASI_DEVIATION_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText2}>
            {Strings.ASI_DEVIATION_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DEVIATION_SUGGESTION_1}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.DEVIATION_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.DEVIATION_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.DEVIATION_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.DEVIATION_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.DEVIATION_SUGGESTION_6}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.DEVIATION_SUGGESTION_7}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.DEVIATION_SUGGESTION_8}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>

          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createDeviationJitterImages()}
          {this.getPageFooter("deviationJitter")}

        </Page>
      );
    }
  }

  createDeviationJitterImages = () => {
    return (
      this.props.deviationJitterImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS_DP}</Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DEVIATION_DP}</Text>
            {parseFloat(data.deviation).toFixed(2).replace(".", ",")} {Strings.MICROSSECOND}
          </Text>

          <Text style={reusableStyles.detectedOnText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- ATTENUATED SIGNAL -----------------
  createAttenuatedSignalPages = () => {
    if (this.props.attenuatedSignal.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{attenuatedSignalPageIndex}{Strings.ASI_ATTENUATED_SIGNAL_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText2}>
            {Strings.ASI_ATTENUATED_SIGNAL_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.ATTENUATED_SIGNAL_SUGGESTION_1}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.ATTENUATED_SIGNAL_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.ATTENUATED_SIGNAL_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.ATTENUATED_SIGNAL_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.ATTENUATED_SIGNAL_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>

          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createAttenuatedSignalImages()}
          {this.getPageFooter("attenuatedSignal")}

        </Page>
      );
    }
  }

  createAttenuatedSignalImages = () => {
    return (
      this.props.attenuatedSignalImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS_DP}</Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE_DP}</Text>
            {(data.amplitude / 1000).toFixed(2)} Vpp
          </Text>

          <Text style={reusableStyles.detectedOnText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- NOISE -----------------
  createNoisePages = () => {
    if (this.props.noise.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{noisePageIndex}{Strings.ASI_NOISE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.ASI_NOISE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.NOISE_SUGGESTION_1}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.NOISE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createNoiseImages()}
          {this.getPageFooter("noise")}

        </Page>
      );
    }
  }

  createNoiseImages = () => {
    return (
      this.props.noiseImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS_DP}</Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL_DP}</Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.detectedOnText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- FAULT -----------------
  createFaultPages = () => {
    if (this.props.fault.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{faultPageIndex}{Strings.ASI_FAULT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.ASI_FAULT_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.FAULT_SUGGESTION_1}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.FAULT_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.FAULT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FAULT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FAULT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FAULT_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.ASI_FAULT_DESCRIPTION_1}</Text>
          <Text style={reusableStyles.lastInfoText}>{Strings.ASI_FAULT_DESCRIPTION_2}</Text>

          <View style={faultRetryStyles.table}>
            {this.createFaultTableHeader()}
            {this.createFaultTable()}
          </View>

          {this.getPageFooter("fault")}

        </Page>
      );
    }
  }

  createFaultTableHeader = () => {
    return (
      <View style={faultRetryStyles.tableRow} fixed>

        <View style={faultRetryStyles.horaryTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={faultRetryStyles.addressTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={faultRetryStyles.channelTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.CHANNEL}</Text>
        </View>

      </View>
    );
  }

  createFaultTable = () => {
    return (
      this.props.fault.map(data => {
        return (
          <View style={faultRetryStyles.tableRow} key={data._id} wrap={false}>

            <View style={faultRetryStyles.horaryTableCol}>
              <Text style={faultRetryStyles.tableCell}>
                {this.formatTime2(data.time, data.ntp)}
              </Text>
            </View>

            <View style={faultRetryStyles.addressTableCol}>
              <Text style={faultRetryStyles.tableCell}>{data.address}</Text>
            </View>

            <View style={faultRetryStyles.channelTableCol}>
              <Text style={faultRetryStyles.tableCell}>{this.props.channel}</Text>
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- RETRY -----------------
  createRetryPages = () => {
    if (this.props.retry.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{retryPageIndex}{Strings.ASI_RETRY_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.ASI_RETRY_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.RETRY_SUGGESTION_1}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.RETRY_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.RETRY_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.RETRY_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.RETRY_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.RETRY_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.ASI_RETRY_DESCRIPTION_1}</Text>
          <Text style={reusableStyles.lastInfoText}>{Strings.ASI_RETRY_DESCRIPTION_2}</Text>

          <View style={faultRetryStyles.table}>
            {this.createRetryTableHeader()}
            {this.createRetryTable()}
          </View>

          {this.getPageFooter("retry")}

        </Page>
      );
    }
  }

  createRetryTableHeader = () => {
    return (
      <View style={faultRetryStyles.tableRow} fixed>

        <View style={faultRetryStyles.horaryTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={faultRetryStyles.addressTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={faultRetryStyles.channelTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.CHANNEL}</Text>
        </View>

      </View>
    );
  }

  createRetryTable = () => {
    return (
      this.props.retry.map(data => {
        return (
          <View style={faultRetryStyles.tableRow} key={data._id} wrap={false}>

            <View style={faultRetryStyles.horaryTableCol}>
              <Text style={faultRetryStyles.tableCell}>
                {this.formatTime2(data.time, data.ntp)}
              </Text>
            </View>

            <View style={faultRetryStyles.addressTableCol}>
              <Text style={faultRetryStyles.tableCell}>{data.address}</Text>
            </View>

            <View style={faultRetryStyles.channelTableCol}>
              <Text style={faultRetryStyles.tableCell}>{this.props.channel}</Text>
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- INVERTED POLARITY -----------------
  createInvertedPolarityPages = () => {
    if (this.props.reversedPolarity.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{invertedPolarityPageIndex}{Strings.ASI_INVERTED_POLARITY_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.INVERTED_POLARITY_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.INVERTED_POLARITY_SUGGESTION_1}</Text>

          <View style={faultRetryStyles.table}>
            {this.createInvertedPolarityTableHeader()}
            {this.createInvertedPolarityTable()}
          </View>

          {this.getPageFooter("reversedPolarity")}

        </Page>
      );
    }
  }

  createInvertedPolarityTableHeader = () => {
    return (
      <View style={faultRetryStyles.tableRow} fixed>

        <View style={faultRetryStyles.horaryTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={faultRetryStyles.addressTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={faultRetryStyles.channelTableColHeader}>
          <Text style={faultRetryStyles.tableCellHeader}>{Strings.CHANNEL}</Text>
        </View>

      </View>
    );
  }

  createInvertedPolarityTable = () => {
    return (
      this.props.reversedPolarity.map(data => {
        return (
          <View style={faultRetryStyles.tableRow} key={data._id} wrap={false}>

            <View style={faultRetryStyles.horaryTableCol}>
              <Text style={faultRetryStyles.tableCell}>
                {this.formatTime2(data.time, data.ntp)}
              </Text>
            </View>

            <View style={faultRetryStyles.addressTableCol}>
              <Text style={faultRetryStyles.tableCell}>{data.address}</Text>
            </View>

            <View style={faultRetryStyles.channelTableCol}>
              <Text style={faultRetryStyles.tableCell}>{this.props.channel}</Text>
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    this.resetSummaryIndexes();
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  leftSubHeaderText: {
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "left",
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  smallSubHeaderLine: {
    height: "1px",
    width: "70px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  detectedOnText: {
    fontSize: 12,
    marginBottom: "4vh",
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText2: {
    fontSize: 12,
    marginBottom: "4vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  noErrors: {
    //marginTop: "28vh",
    textAlign: "center",
    fontSize: 12,
    //marginBottom: "4vh",
    //fontWeight: "bold",
    fontFamily: "RobotoRegular"
  },

  tabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  tabbedText2: {
    fontSize: 12,
    //marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  doubleTabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 20,
    fontFamily: "RobotoRegular"
  },
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const terminationOffStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 20
  },

  pageTitle: {
    fontSize: 18,
    //marginTop: "2vh",
    marginBottom: "2vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "2vh",
    height: "20vh",
    width: "60vw"
  }
});

const faultRetryStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  addressTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  channelTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  addressTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  channelTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  }
});

export default TsExpertReport;
